export class ElementSize {
  constructor(public width: number, public height: number) {}
}
